import type { SVGProps } from "react";

export type LandingIconProps = SVGProps<SVGSVGElement>;

const baseProps: LandingIconProps = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
};

export function ArrowRightIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M5 12h14" /><path d="m14 7 5 5-5 5" /></svg>;
}

export function BedIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M3 18v-8" /><path d="M21 18v-5a3 3 0 0 0-3-3H9v8" /><path d="M3 13h18" /><path d="M7 10V7h4a2 2 0 0 1 2 2v1" /></svg>;
}

export function BotIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><rect x="4" y="7" width="16" height="12" rx="3" /><path d="M9 11h.01M15 11h.01M8 15h8M12 7V4M10 4h4" /></svg>;
}

export function CalendarIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></svg>;
}

export function CameraIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M14.5 5 13 3h-2L9.5 5H6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-3.5Z" /><circle cx="12" cy="13" r="4" /></svg>;
}

export function CheckIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="m5 12 4 4L19 6" /></svg>;
}

export function ChevronDownIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="m6 9 6 6 6-6" /></svg>;
}

export function CompassIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><circle cx="12" cy="12" r="9" /><path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" /></svg>;
}

export function HomeIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="m3 11 9-8 9 8" /><path d="M5 10v10h14V10" /><path d="M9 20v-6h6v6" /></svg>;
}

export function ImageIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="m21 15-4-4L5 20" /></svg>;
}

export function MapPinIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></svg>;
}

export function ReceiptIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" /><path d="M9 8h6M9 12h6M9 16h3" /></svg>;
}

export function RouteIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><circle cx="5" cy="17" r="2" /><circle cx="19" cy="7" r="2" /><path d="M6.7 15.9c3.8-6.4 6.8-8.2 10.3-8.7" /><path d="M8 7h3M9.5 5.5v3" /></svg>;
}

export function SearchIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></svg>;
}

export function SparklesIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="m12 3 1.2 3.3L16.5 7.5l-3.3 1.2L12 12l-1.2-3.3-3.3-1.2 3.3-1.2L12 3Z" /><path d="m18.5 13 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z" /><path d="m5 14 .7 1.8 1.8.7-1.8.7L5 19l-.7-1.8-1.8-.7 1.8-.7L5 14Z" /></svg>;
}

export function SplitIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M6 3v4c0 3 2 5 5 5h7" /><path d="m15 9 3 3-3 3" /><path d="M6 21v-4c0-3 2-5 5-5" /></svg>;
}

export function UploadIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M12 16V4" /><path d="m7 9 5-5 5 5" /><path d="M4 15v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" /></svg>;
}

export function UsersIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
}

export function VoteIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="m9 11 2 2 4-4" /><path d="M5 4h14v10H5z" /><path d="M3 14h18v6H3z" /></svg>;
}

export function WalletIcon(props: LandingIconProps) {
    return <svg {...baseProps} {...props}><path d="M4 6h14a2 2 0 0 1 2 2v10H4a2 2 0 0 1-2-2V6a3 3 0 0 1 3-3h13" /><path d="M16 11h6v4h-6a2 2 0 0 1 0-4Z" /></svg>;
}
